import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import BrowserTabUidManager from '../../../../../../library/clxProductNet/assets/js/modules/common/tracking/browserTabUidManager';
import MicroConversionTracker from '../../../../../../library/clxProductNet/assets/js/modules/common/tracking/microConversionTracker';
import {RequestFailedError} from '../../common/errors';
import {getLocale} from '../../common/locale';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';
import ProductCustomizationTrackingModel from '../Model/productCustomizationTrackingModel';
import PricingOverviewService from '../Service/pricingOverviewService';

export default class CustomizationPricingOverviewComponent extends HTMLElement {
    private readonly pricingOverviewService: PricingOverviewService;
    private config: ProductCustomizationConfigModel;
    private readonly microConversionTracker: MicroConversionTracker;

    constructor() {
        super();

        this.microConversionTracker = new MicroConversionTracker(`/${getLocale()}/product-customization/apiTrack/`);
        const browserTabUidManager = new BrowserTabUidManager();
        this.pricingOverviewService = new PricingOverviewService(this.microConversionTracker, browserTabUidManager);
        this.config = ProductCustomizationConfigModel.getInstance();
    }

    public async refreshOverviewUIAndHandleErrors(productCustomizationConfig: ProductCustomizationConfigModel, eventName: string): Promise<void> {
        this.config = productCustomizationConfig;

        // if the sku amount is empty, we cannot update the prices because there is no price for amount 0
        // this request would fail with a 500 error
        if (this.config.hasEmptySkuAmount()) {
            return;
        }

        const response = await this.pricingOverviewService.refreshOverviewUI(this.config, eventName);

        if (response instanceof RequestFailedError) {
            return;
        }

        this.innerHTML = response;
    }

    public async refreshOverviewPricesAndHandleErrors(productCustomizationConfig: ProductCustomizationConfigModel, eventName: string): Promise<void> {
        this.config = productCustomizationConfig;

        // if the sku amount is empty, we cannot update the prices because there is no price for amount 0
        // this request would fail with a 500 error
        if (this.config.hasEmptySkuAmount()) {
            return;
        }

        const response = await this.pricingOverviewService.refreshOverviewPrices(this.config, eventName);

        if (response instanceof RequestFailedError) {
            return;
        }

        const htmlContainerIds = Object.keys(response);
        for (const htmlContainerId of htmlContainerIds) {
            const htmlContainer = notNull(document.getElementById(htmlContainerId));
            htmlContainer.innerHTML = response[htmlContainerId];
        }

        let trackingModel = new ProductCustomizationTrackingModel(productCustomizationConfig);
        this.microConversionTracker.trackWithBeacon(eventName, trackingModel.getAsJsonStringForTracking());
    }
}
customElements.define('clx-customization-pricing-overview', CustomizationPricingOverviewComponent);
